export const DashboardTablesTypes = {
    GET_DASHBOARD_TABLES:'GET_DASHBOARD_TABLES',
}